module.exports = __webpack_public_path__ + "static/mukaiImg1-05ea2edf99a18ce35565918101f1eb56.jpg";